// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_TOAST_STATUS = '@customization/SET_TOAST_STATUS';
export const SET_TOAST_OBJECT = '@customization/SET_TOAST_OBJECT';
export const SET_LOADING = '@customization/SET_LOADING';
export const SET_ACTIVE_PAGE = '@customization/SET_ACTIVE_PAGE';
export const SET_USER_DATA = '@customization/SET_USER_DATA';
export const SET_USER_PROFILE = '@customization/SET_USER_PROFILE';
export const SET_COMPANY_DATA = '@customization/SET_COMPANY_DATA';
export const SET_COMPANY_PROFILE = '@customization/SET_COMPANY_PROFILE';
export const SET_COMPANY_PROFILE_IS_UPDATING = '@customization/SET_COMPANY_PROFILE_IS_UPDATING';
export const SET_UNREAD_QUESTIONS = '@customization/SET_UNREAD_QUESTIONS';
export const SET_MODAL_STATUS = '@customization/SET_MODAL_STATUS';
export const SET_TEAM_MEMBERS = '@customization/SET_TEAM_MEMBERS';
export const SET_EVENTS = '@customization/SET_EVENTS';
export const SET_EVENT_DATE = '@customization/SET_EVENT_DATE';
export const SET_ONBOARDING_DATA = '@customization/SET_ONBOARDING_DATA';
export const NOT_SET_ONBOARDING_DATA = '@customization/NOT_SET_ONBOARDING_DATA';
export const LOADING_ONBOARDING_DATA = '@customization/LOADING_ONBOARDING_DATA';
export const SWITCHED_COMPANY = '@customization/SWITCHED_COMPANY';
export const SET_MODAL_TYPE = '@customization/SET_MODAL_TYPE';
export const CLEAR_DATA = '@customization/CLEAR_DATA';
export const SET_FIRST_TIME_LOGIN = '@customization/SET_FIRST_TIME_LOGIN';
export const SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK = '@customization/SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK';
export const SET_INPUT_CHANGES_FOR_LOCK = '@customization/SET_INPUT_CHANGES_FOR_LOCK';
export const SET_NEW_TOKEN = '@customization/SET_NEW_TOKEN';
export const SET_CALENDAR_SECTION_LOADING = '@customization/SET_CALENDAR_SECTION_LOADING';
export const SET_IS_CALENDAR_FROM_EDIT_ADD_AND_DELETE = '@customization/SET_IS_CALENDAR_FROM_EDIT_ADD_AND_DELETE';
export const SET_SELECTED_NAV_ITEM = '@customization/SET_SELECTED_NAV_ITEM';
export const SET_AUTHORIZED_USERS = '@customization/SET_AUTHORIZED_USERS';
export const SET_NAV_RELOAD = '@customization/SET_NAV_RELOAD';
